var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
  'font-size-s': _vm.fontSize === -1,
  'font-size-xs': _vm.fontSize === -2,
  'font-size-l': _vm.fontSize === 1,
  'font-size-xl': _vm.fontSize === 2,
  'hight-contrast': _vm.contrast,
  'dark': _vm.dark || _vm.contrast,
  'fullscreen': _vm.isFullscreen
}, _obj[_vm.breakpoint] = _vm.breakpoint, _obj['loading-data'] =  !_vm.dataLoaded, _obj ),attrs:{"id":"app"}},[_c('div',{staticClass:"pages"},[_c('transition',{attrs:{"name":"router-anim"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }